import PropTypes from 'prop-types';
import React from 'react';
import { Link } from '@spotahome/ui-library';

import internalLinkingModule from '../../shapes/internalLinking';

const InternalLinkingModules = ({ internalLinking }) => {
  return internalLinking.map(module => {
    return (
      <div className="internal-linking internal-linking--module">
        <h2 className="internal-linking__title">{module.title}</h2>
        <div className="internal-linking__links--container internal-linking--module-links">
          {module.links.map(link => {
            return <Link href={link.url}>{link.anchorText}</Link>;
          })}
        </div>
      </div>
    );
  });
};

InternalLinkingModules.propTypes = {
  internalLinking: PropTypes.arrayOf(PropTypes.shape(internalLinkingModule))
    .isRequired
};

export default InternalLinkingModules;
